const state = {
  isPromoModalOpen: false,
  editPromoItem: null,
  promoModalAction: null,
  currentPromos: ["test"],
};

const getters = {
  promoModal: state => state.isPromoModalOpen,
  editPromo: state=> state.editPromoItem,
  action: state=> state.promoModalAction,
  promos: state => state.currentPromos,
};

const actions = {
  showPromoModal: ({commit}, actionPayload)=>{
    commit('setShowPromoModal', actionPayload);
  },
  setPromoEditItem: ({commit}, promoItem)=>{
    commit('setEditItem', promoItem);
  },
  setPromoModalAction: ({commit}, newAction)=>{
    commit('setAction', newAction);
  },
  setPromos: ({commit}, promosPayload)=>{
    commit('setCurrentPromos', promosPayload);
  }
};

const mutations = {
  setShowPromoModal: (state, shouldShow)=>{
    state.isPromoModalOpen = shouldShow;
  },
  setEditItem: (state, promoItem)=>{
    state.editPromoItem = promoItem;
  },
  setAction: (state, action) =>{
    state.promoModalAction = action;
  },
  setCurrentPromos: (state, newPromos)=>{
    state.currentPromos = newPromos;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};